'use client'

import {Link, useLocation} from 'react-router-dom'
import useWindowSize from 'src/components/slider/hooks/useWindowSize'
import {useAppSidebar} from 'src/layouts/main-layout/app-sidebar/app-sidebar-context'
import {NavigationMenuType} from 'src/layouts/main-layout/app-sidebar/navigation/types/navigation-menu.type'
import {isPathActive} from 'src/layouts/main-layout/app-sidebar/utils/is-path-active.helper'
import {cn} from 'src/layouts/main-layout/app-sidebar/utils/utils'
import {tv} from 'tailwind-variants'

const subnavWrapVariants = tv({
  base: ['relative mt-1'],
})

const subnavLineVariants = tv({
  base: [
    'relative',
    'before:absolute before:left-6 before:-translate-x-1/2 before:h-full',
    "before:bg-sidebar-foreground before:content-['']",
    'before:w-px',
    'transition-[before-width] duration-200',
  ],
  variants: {
    active: {
      true: 'before:w-0.5 before:rounded-full',
      false: 'before:w-px',
    },
  },
})

const subItemVariants = tv({
  base: [
    'flex w-full items-center rounded-lg h-12 pl-12 pr-4 text-sm text-sidebar-foreground hover:bg-[#182B4466]',
    'transition-colors',
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
  ],
  variants: {
    active: {
      true: 'text-sidebar-foreground font-bold',
      false: '',
    },
  },
})

interface Props {
  items: Pick<NavigationMenuType, 'id' | 'label' | 'route'>[]
}

export function AppSidebarSubnav({items}: Props) {
  const {pathname} = useLocation()
  const {toggleCollapsed} = useAppSidebar()

  const isChildActive = (route: string) => {
    return isPathActive(pathname, route)
  }

  const {width} = useWindowSize()
  const mobileWidth = width <= 767

  return (
    <div data-slot='sidebar-subnav' className={cn(subnavWrapVariants())}>
      {items.map((sub) => {
        const active = isChildActive(sub.route)
        return (
          <Link to={sub.route} key={sub.id} style={{textDecoration: 'none'}}>
            <button
              key={sub.id}
              type='button'
              title={sub.label}
              data-slot='sidebar-subitem'
              onClick={() => mobileWidth && toggleCollapsed()}
              data-active={active ? active : undefined}
              className={cn(subItemVariants({active}), subnavLineVariants({active}))}>
              <span className='min-w-0 flex-1 truncate text-left'>{sub.label}</span>
            </button>
          </Link>
        )
      })}
    </div>
  )
}
